import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from "react-redux";
import {
  getListCauHinhGoiTraGop,
  updateDataSearch,
} from "../../../../actions/CauHinhGoiTraGop";
import { currentDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import { convertToNumber } from "utils/numberExtension";
import { pushNotification } from "utils/notifications";
import userApi from "../../../../service/userApi";
import NguonVonApi from "../../../../service/nguonVonApi";
import BanHangTraGopApi from "service/banHangTraGopApi";
export const ModalThemMoi = (props) => {
  const dataSearch = useSelector((state) => state.dataSearchCauHinhGoiTraGop);
  const dispatch = useDispatch();
  const [isSubbmit, setIsSubmit] = useState(false);
  const initData = {
    Id: 0,
    TenSanPham: "",
    TrangThai: true,
  };
  const [dataCauHinh, setDataCauHinh] = useState(initData);

  //Set Data khi Update trường dữ liệu
  const updateTextValue = (field) => (e) => {
    setDataCauHinh({
      ...dataCauHinh,
      [field]: e.target.value,
    });
    if (e.target.value === "") {
      setErrors({
        ...errors,
        ten: "Nhập tên sản phẩm",
      });
    } else {
      setErrors({
        ...errors,
        ten: "",
      });
    }
  };
  const TenTaiSan = React.createRef();
  useEffect(() => {
    if (props.Id > 0) {
      setDataCauHinh({
        ...dataCauHinh,
        TenSanPham: props.item.TenSanPham,
        Id: props.Id,
      });
    }
  }, []);

  //Thông báo
  const validateName = (nguoinop) => {
    const expression = /(\w.).+/i;
    return expression.test(String(nguoinop).toLowerCase());
  };

  const initErrors = {
    ten: "",
  };
  const [errors, setErrors] = useState(initErrors);

  const onSubmit = () => {
    const value = { ...dataCauHinh };
    if (value.TenSanPham === "") {
      TenTaiSan.current.focus();
      setErrors({
        ...errors,
        ten: "Nhập tên sản phẩm",
      });
      return;
    }

    if (props.Id > 0) {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiTraGop(params).then((response) => {
        if (response.status == 200) {
          pushNotification(
            "Cập nhật tên sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          props.onHide();
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
        console.log(response, "aaaaaaaaaaaaaaaa");
      });
    } else {
      setIsSubmit(true);
      const param2 = value;
      var params = param2;
      BanHangTraGopApi.addCauHinhGoiTraGop(params).then((response) => {
        if (response.status == 200) {
          pushNotification(
            "Thêm mới tên sản phẩm thành công",
            "success",
            "TOP_RIGHT",
            2000
          );
          props.onHide();
          dispatch(getListCauHinhGoiTraGop(dataSearch));
          setIsSubmit(false);
        } else {
          setIsSubmit(false);
          pushNotification(response.data.Message, "error", "TOP_RIGHT", 1000);
        }
        console.log(response, "aaaaaaaaaaaaaaaa");
      });
    }
  };
  return (
    <Modal
      {...props}
      size="modal-dialog modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fas fa-plus"></i>
          </span>{" "}
          {props.Id > 0 ? "Sửa" : "Thêm mới"}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="form-body">
              <div className="form-group">
                <label className=" label-control text-left">Tên sản phẩm</label>

                <input
                  type="text"
                  className="form-control input-sm"
                  value={dataCauHinh.TenSanPham}
                  onChange={updateTextValue("TenSanPham")}
                  name="SoLanGiaHan"
                  ref={TenTaiSan}
                />
              </div>
              {errors.ten && (
                <div className="form-group row">
                  <div className="col-md-12">
                    <span
                      className="canh-bao-red"
                      style={{ marginBottom: "10px" }}
                    >
                      {errors.ten}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          type="button"
          className="btn btn-new-main btn-checknew"
          onClick={onSubmit}
          disabled={isSubbmit}
        >
          <span className="btn-icon-left">
            {props.customerId > 0 ? (
              <i class="mdi mdi-check"></i>
            ) : (
              <i class="mdi mdi-plus"></i>
            )}
          </span>{" "}
          {props.Id > 0 ? "Xác nhận" : "Thêm mới"}
        </button>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
